module.exports = __webpack_public_path__ + "static/media/optima-seguros-street-selected.bffa3e4b.svg";